var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mf-toolbar',{attrs:{"logo":_vm.toolbarLogo,"logo-click-action":_vm.goToHome},scopedSlots:_vm._u([{key:"extension",fn:function(){return undefined},proxy:true}])},[_c('span',{staticClass:"client-name"},[_vm._v(_vm._s(_vm.$getLoggedUser().client))]),_c('logged-user-menu',{staticClass:"logged-user-menu"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }